import * as React from 'react';
import { useEffect, useState } from 'react';
import { Alert, Button, Card, CardText, CardTitle, Col, FormFeedback, FormGroup, Input, Label, Row, Toast, ToastBody, ToastHeader } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { AfrEvents, DiscrepancyEvent, EmailEventInput, getDiscrepancyEvents, getSelectedEvents, postDiscrepancy } from '../../redux/EventsSlice';
import dateHelper from '../../utils/dateHelper';
import WYSIWYGEditor from './WYSIWYGEditor';


const DiscrepancyEmail = (props: {allowEdit: boolean}) => {
    const dispatch = useAppDispatch();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);

    const selectedEntity: Entity | null = useAppSelector(getSelectedEntity);
     
    const currentAfrEvents: AfrEvents | null = useAppSelector(getSelectedEvents);

    const AFRDiscrepancy: DiscrepancyEvent = { afrId:"", entityName:"", firstDiscrepancy:null, secondDiscrepancy:null, thirdDiscrepancy: null }

    const [subject, setSubject] = useState("");
    const [selectedDiscrepancy, setSelectedDiscrepancy] = useState("FIRST");
    const [body, setBody] = useState('');
    const [emailSentDate, setEmailSentDate] = useState("");
    const [currentDiscrepancies, setCurrentDiscrepancies] = useState<any>(AFRDiscrepancy);
    


    const handleDiscrepancyChange = function (event: any) {
        setSelectedDiscrepancy(event.target.value);
        loadEmailInformation(event.target.value);

    }

    const handleSendDiscrepancy = function (event: any) {

        if (!(isValid("subject") && isValid("body"))) { return; }


        var htmlText = 'Please take into account that this action cannnot be rolled back ' +
            'if you select <b>YES</b>.<br/><br/>' +
            'Do you want to send the discrepancy email? ';

        var textResponse = 'The email has been sent.';

        if (currentAfr && selectedEntity) {

            Swal.fire({
                title: 'Are you sure you want to send the email?',
                html: htmlText,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, send it!'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    // Send the email here
                    var afrId = selectedEntity.code + "," + currentAfr.year;
                    var discReq: EmailEventInput = {
                        connector: afrId,
                        payload: "",
                        message: {
                            recipientId: "@primary",
                            subject: subject,
                            body: body
                        },
                        isResponse: false,
                        role: "DISCREPANCY_MESSAGE"
                    };
                    dispatch(postDiscrepancy(discReq));

                    Swal.fire(
                        'Email just sent!',
                        textResponse,
                        'success'
                    )
                }

            });

        }


    }


    const showAlertWhenNoDiscrepancies = function () {
        if (props.allowEdit) {
            return false;
        }
        if (currentDiscrepancies) {
            return (currentDiscrepancies.firstDiscrepancy === null && currentDiscrepancies.secondDiscrepancy === null && currentDiscrepancies.thirdDiscrepancy === null);
        }
        return true;
    }
    const pendingDiscrepancies = function () {
        return (!(currentDiscrepancies && currentDiscrepancies.firstDiscrepancy && currentDiscrepancies.secondDiscrepancy && currentDiscrepancies.thirdDiscrepancy))
    }

    const isDiscrepancyEnabled = function (discrepancy: string) {
        var isCurrent = (isCurrentDiscrepancy() === discrepancy);
        if (currentDiscrepancies) {
            switch (discrepancy) {
                case "FIRST":
                    if (currentDiscrepancies.firstDiscrepancy === null && !props.allowEdit) {
                        return false;
                    }
                    if (isCurrent && currentDiscrepancies.firstDiscrepancy === null) {
                        return true;
                    }
                    if (currentDiscrepancies.firstDiscrepancy && pendingDiscrepancies()) {
                        return true;
                    }
                    if (!pendingDiscrepancies() && currentDiscrepancies.firstDiscrepancy) {
                        return true;
                    }
                    break;
                case "SECOND":
                    if (currentDiscrepancies.secondDiscrepancy === null && !props.allowEdit) {
                        return false;
                    }
                    if (isCurrent && currentDiscrepancies.secondDiscrepancy === null) {
                        return true;
                    }
                    if (currentDiscrepancies.secondDiscrepancy && pendingDiscrepancies()) {
                        return true;
                    }
                    if (!pendingDiscrepancies() && currentDiscrepancies.secondDiscrepancy) {
                        return true;
                    }
                    break;
                case "THIRD":
                    if (currentDiscrepancies.thirdDiscrepancy === null && !props.allowEdit) {
                        return false;
                    }
                    if (isCurrent && currentDiscrepancies.thirdDiscrepancy === null) {
                        return true;
                    }
                    if (currentDiscrepancies.thirdDiscrepancy && pendingDiscrepancies()) {
                        return true;
                    }
                    if (!pendingDiscrepancies() && currentDiscrepancies.thirdDiscrepancy) {
                        return true;
                    }
                    break;
            }
        }
        return false;
    }


    const isCurrentDiscrepancy = function () {

        if (currentDiscrepancies) {

            if (props.allowEdit) {
                if (currentDiscrepancies.firstDiscrepancy === null) {
                    return "FIRST";
                }
                if (currentDiscrepancies.secondDiscrepancy === null) {
                    return "SECOND";
                }
                if (currentDiscrepancies.thirdDiscrepancy === null) {
                    return "THIRD";
                }
            } else {

                if (currentDiscrepancies.thirdDiscrepancy ) {
                    return "THIRD";
                }
                if (currentDiscrepancies.secondDiscrepancy) {
                    return "SECOND";
                }
                if (currentDiscrepancies.thirdDiscrepancy) {
                    return "FIRST";
                }
            }

        }
        return "";
    }

    const isValid = function (field: string) {
        var result: boolean = true;
        switch (field) {
            case "subject":
                if (subject.length === 0) {
                    result = false;
                }
                break;
            case "body":
                if (!body || body.trim().length === 0 || body === "<p><br></p>") {
                    result = false;
                }
                break;
        }
        return result;
    }

    const loadEmailInformation = function (selected: string) {
        setEmailSentDate("");
        setSubject("");
        setBody("");

        if (currentDiscrepancies) {

            if (props.allowEdit) {
                setSubject("Discrepancy Email –[" + currentDiscrepancies.afrId.split("^")[0] + "]–[" + currentDiscrepancies.entityName + "]– FY " + currentDiscrepancies.afrId.split("^")[1] + " AFR");
                if (selected === "THIRD") {
                    setSubject("Escalation Call –[" + currentDiscrepancies.afrId.split("^")[0] + "]–[" + currentDiscrepancies.entityName + "]– FY " + currentDiscrepancies.afrId.split("^")[1] + " AFR");
                }

            }

            if (selected === "FIRST") {
                if (currentDiscrepancies.firstDiscrepancy) {
                    setEmailSentDate(dateHelper.stringDateInFormat(currentDiscrepancies.firstDiscrepancy.timestamp, "LL/dd/yyyy"));
                    setSubject(currentDiscrepancies.firstDiscrepancy.message.subject);
                    setBody(currentDiscrepancies.firstDiscrepancy.message.body);
                }
            }

            if (selected === "SECOND") {
                if (currentDiscrepancies.secondDiscrepancy) {
                    setEmailSentDate(dateHelper.stringDateInFormat(currentDiscrepancies.secondDiscrepancy.timestamp, "LL/dd/yyyy"));
                    setSubject(currentDiscrepancies.secondDiscrepancy.message.subject);
                    setBody(currentDiscrepancies.secondDiscrepancy.message.body);
                }
            }

            if (selected === "THIRD") {
                if (currentDiscrepancies.thirdDiscrepancy) {
                    setEmailSentDate(dateHelper.stringDateInFormat(currentDiscrepancies.thirdDiscrepancy.timestamp, "LL/dd/yyyy"));
                    setSubject(currentDiscrepancies.thirdDiscrepancy.message.subject);
                    setBody(currentDiscrepancies.thirdDiscrepancy.message.body);
                }
            }

        }
    }



    /* *****************************************************************************
     * Events and Effects
     *******************************************************************************/
    useEffect(function () {
        setCurrentDiscrepancies(AFRDiscrepancy);
        if (currentAfr && selectedEntity && currentAfrEvents  ) {
            setCurrentDiscrepancies(getDiscrepancyEvents(currentAfr, selectedEntity, currentAfrEvents));
        }

    }, [currentAfrEvents]);


    useEffect(function () {

        var selected: string = "";
        var currentDiscrepancy = isCurrentDiscrepancy();

        if (currentDiscrepancy === null) { return }
       
        if (currentDiscrepancy.length > 0) {
            selected = currentDiscrepancy;
        } else {
            selected = "FIRST";
        }

        setSelectedDiscrepancy(selected);
        loadEmailInformation(selected);


    }, [currentDiscrepancies]);

//    console.log("Current Discrepancies:", currentDiscrepancies);

    /*******************************************************************************/
    return (
        <React.Fragment>
            { currentDiscrepancies && (
                <div>
                    <Toast className="auditDetail">
                        <ToastHeader className="auditDetail">Discrepancy Emails</ToastHeader>
                        <ToastBody>
                            <div>

                                        <Row>
                                            <Col sm="9">
                                        
                                        {showAlertWhenNoDiscrepancies() ?
                                            (
                                                <Alert color="danger">
                                                    <p>There are no discrepancies associated to the selected entity!</p>
                                                </Alert>
                                            ) : (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col md="6">
                                                                <Card body>
                                                                    <CardTitle></CardTitle>
                                                                    <CardText>
                                                                        <Label className="ml-4" check>
                                                                            <Input type="radio"
                                                                                name="radioFilterFirst"
                                                                                value={"FIRST"}
                                                                                onChange={handleDiscrepancyChange}
                                                                                checked={(selectedDiscrepancy === "FIRST")}
                                                                                disabled={(!(isDiscrepancyEnabled("FIRST")))}
                                                                            /><b>First</b>
                                                                        </Label>
                                                                        <Label className="ml-5" check>
                                                                            <Input type="radio"
                                                                                name="radioFilterSecond"
                                                                                value={"SECOND"}
                                                                                onChange={handleDiscrepancyChange}
                                                                                checked={(selectedDiscrepancy === "SECOND")}
                                                                                disabled={(!(isDiscrepancyEnabled("SECOND")))}
                                                                            /><b>Second</b>
                                                                        </Label>
                                                                        <Label className="ml-5" check>
                                                                            <Input type="radio"
                                                                                name="radioFilterThird"
                                                                                value={"THIRD"}
                                                                                onChange={handleDiscrepancyChange}
                                                                                checked={(selectedDiscrepancy === "THIRD")}
                                                                                disabled={(!(isDiscrepancyEnabled("THIRD")))}
                                                                            /><b>Third</b>
                                                                        </Label>
                                                                    </CardText>
                                                                </Card>
                                                        
                                                        </Col>
                                                        <Col md="6" className="text-md-left">

                                                             {(emailSentDate && emailSentDate.length > 0) ? (<Label className="mt-5"><b>Email Sent: </b>{emailSentDate}</Label>) : ""}

                                                        </Col>
                                                    </Row>
                                                    <FormGroup>

                                                        <Row>
                                                            <Col className="text-md-right" >
                                                                <Label><b>Subject:</b></Label>
                                                            </Col>
                                                            <Col md="9">
                                                                <Input type="text" value={subject} disabled={( (isCurrentDiscrepancy() != selectedDiscrepancy) || !props.allowEdit) }
                                                                    onChange={(e) => setSubject(e.currentTarget.value)}
                                                                    valid={isValid("subject")}
                                                                    invalid={(!isValid("subject"))} />
                                                                <FormFeedback>Subject is required.</FormFeedback>
                                                            </Col>
                                                        </Row>

                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col className="text-md-right" >
                                                                <Label><b>Email:</b></Label>
                                                            </Col>
                                                            <Col md="9">
                                                                                                        
                                                                <WYSIWYGEditor
                                                                    content={body}
                                                                    setContent={setBody}
                                                                    readOnly={(isCurrentDiscrepancy() != selectedDiscrepancy) || !props.allowEdit }

                                                                />

                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <Row>
                                                        <Col md="12" className="text-md-right">
                                                            {(isCurrentDiscrepancy() === selectedDiscrepancy) && (props.allowEdit) && (<Button type="button" name="save-discrepancy" visible={(isCurrentDiscrepancy() === selectedDiscrepancy) ? "true" : "false" } onClick={handleSendDiscrepancy}>Save</Button>)}
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                                )}
                                            
                                            </Col>


                                        </Row>



                            </div>


                        </ToastBody>
                    </Toast>


                </div>
            )}
        </React.Fragment>
    );
};

export default DiscrepancyEmail;